var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotWarrantyIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45611 20.8637C7.05189 21.0805 6.55945 21.048 6.1872 20.78C5.81496 20.512 5.62797 20.0553 5.70538 19.6032L6.57374 14.5781L2.89621 11.0176C2.57119 10.698 2.45524 10.2218 2.59691 9.78854C2.73858 9.35526 3.11342 9.0396 3.56449 8.97373L8.64861 8.24042L10.9196 3.66452C11.1247 3.2547 11.5437 2.99588 12.002 2.99588C12.4603 2.99588 12.8793 3.2547 13.0845 3.66452L15.3554 8.24042L20.4395 8.97373C20.8906 9.0396 21.2654 9.35526 21.4071 9.78854C21.5488 10.2218 21.4328 10.698 21.1078 11.0176L17.4283 14.5761L18.2966 19.6012C18.375 20.0536 18.1884 20.5111 17.8159 20.7797C17.4435 21.0483 16.9505 21.0809 16.5459 20.8637L12 18.4937L7.45611 20.8637Z",
    stroke: "#AA4BD7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2505 11.4578L10.7495 13.9588",
    stroke: "#AA4BD7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7495 11.4578L13.2505 13.9588",
    stroke: "#AA4BD7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotWarrantyIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NotWarrantyIcon.982f6ad7.svg";
export { ForwardRef as ReactComponent };